// extracted by mini-css-extract-plugin
module.exports = {"calorieResults":"CalorieResults_calorieResults__tiSz7","info":"CalorieResults_info__2nfJd","resultNum":"CalorieResults_resultNum__3mpDr","active":"CalorieResults_active__2LcWK"};